import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchPrivateMatter {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  limit?: number;
  search?: string;
  customerId?: string;
  withHasSubMatters?: boolean;
}
export const useFetchPrivateMatter = (params: IUseFetchPrivateMatter) => {
  const fetchPrivateMatter = async ({ pageParam = 1 }) => {
    const { relations: matterRelations, customerId, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (matterRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    try {
      return await get(
        `${API_URLS.PRIVATE_PERSON_MATTERS.replace(':id', String(customerId))}?${queryString.toString()}`,
      );
    } catch (error) {
      console.error('Error fetching private matter:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch private matter');
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['private-matter', params],
    queryFn: fetchPrivateMatter,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
